import { render, staticRenderFns } from "./year-select-index.vue?vue&type=template&id=6d8174e8&scoped=true&"
import script from "./year-select-index.vue?vue&type=script&lang=js&"
export * from "./year-select-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8174e8",
  null
  
)

export default component.exports